import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/homePage';
import ContactUs from './pages/ContactPage';
import Search from './pages/SearchPage';
import NSDetailsPage from "./pages/NSDetailsPage";
import Bread from './pages/BreadPage'
import Pastry from './pages/PastryPage'
import Cake from './pages/CakePage'
import Doughnut from './pages/DougnutsPage'
import PandC from './pages/PiesCookiesPage'
import Muffins from './pages/MuffinsPage'
import Rcake from './pages/RCake'
import Od from './pages/OtherDesserts'
import Iwd from './pages/IndWrapDesserts'
import Iwb from './pages/IndWrapBreakfast'
import Ids from './pages/IndDessertServ'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/search" element={<Search />} />
        <Route path="/ns/:nsCode" element={<NSDetailsPage />} />
        <Route path="/bread" element={<Bread />} />
        <Route path="/pastry" element={<Pastry />} />
        <Route path="/cake" element={<Cake />} />
        <Route path="/doughnut" element={<Doughnut />} />
        <Route path="/pies" element={<PandC />} />
        <Route path="/muffins" element={<Muffins />} />
        <Route path='/rcake' element={<Rcake />} />
        <Route path='/od' element={<Od />} />
        <Route path='/iwd' element={<Iwd />} />
        <Route path='/iwb' element={<Iwb />} />
        <Route path='/ids' element={<Ids />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

